export type { GetAddressDataResponse } from './get-address-data'
export { getAddressData } from './get-address-data'
